import { render, staticRenderFns } from "./GalleryTabReadOnly.vue?vue&type=template&id=307939dc&"
import script from "./GalleryTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./GalleryTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports